module.exports = __webpack_public_path__ + "static/media/ProximaNova-RegularIt.5f5d2168.eot";